<script setup lang="ts">
import type { LinkField } from '@prismicio/client'

const props = defineProps<{
  field: LinkField
  track?: string | null
}>()

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

function onClick() {
  if (!props.track) return
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return

  const url = props.field && 'url' in props.field ? props.field.url : undefined
  const text = props.field && 'text' in props.field ? props.field.text : undefined

  window.gtag('event', 'cta_click', {
    cta_type: props.track,
    link_url: url,
    link_text: text,
  })
}
</script>

<template>
  <PrismicLink :field="field" v-bind="$attrs" @click="onClick">
    <slot />
  </PrismicLink>
</template>
